import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const AUTH_ORGANIZATION_CODE: {
  ORGANIZATION_DELETE_HAS_SUBSCRIPTION: MvnCodeBE;
  ORGANIZATION_OWNER_CHANGE_FAIL: MvnCodeBE;
} = {
  ORGANIZATION_DELETE_HAS_SUBSCRIPTION: {
    code: "ORGANIZATION_DELETE_HAS_SUBSCRIPTION",
    status: 409,
    ko: "구독 중인 조직은 삭제할 수 없습니다.",
    en: "The organization in subscription cannot be deleted.",
  },
  ORGANIZATION_OWNER_CHANGE_FAIL: {
    code: "ORGANIZATION_OWNER_CHANGE_FAIL",
    status: 400,
    ko: "Organization Owner 변경에 실패하였습니다.",
    en: "Failed to change the organization Owner.",
  },
};

MvnCodeInitiate(AUTH_ORGANIZATION_CODE);
